var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeam = function SvgTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Team_svg__a)",
    stroke: "current",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.667A5.333 5.333 0 1 0 12 4a5.333 5.333 0 0 0 0 10.667ZM4 28v-2.667A5.333 5.333 0 0 1 9.333 20h5.334A5.333 5.333 0 0 1 20 25.333V28",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 28h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.333 14.667 24 17.333 29.333 12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Team_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgTeam;